<template>
	<div class="receivingHistory">
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline search-form">
				<el-form-item label="姓名：">
					<el-autocomplete v-model.trim="formInline.name" :fetch-suggestions="querySearchAsync" clearable placeholder="请输入内容"></el-autocomplete>
				</el-form-item>
				<el-form-item label="性别：">
					<el-select v-model="formInline.genderDictionaryItemId" placeholder="请选择">
						<el-option v-for="(item, index) in sexDictionaryItemList" :key="index" :label="item.title" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:is-show-selection="false"
				:showOperation="false"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
			</Table>
		</div>
	</div>
</template>

<script>
import { getAge } from '@/utils/formatTime';
export default {
	name: 'receivingHistory',
	components: {
		Table: () => import('@/components/Table/table'),
	},
	data() {
		return {
			loading: false,
			formInline: {
				name: '',
				genderDictionaryItemId: null,
			},
			sexDictionaryItemList: [],
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			tableHead: [
				{
					label: '患者姓名',
					prop: 'person',
					formatter: (row) => {
						return row.person?.name || '-';
					},
				},
				{
					label: '性别',
					prop: 'person',
					formatter: (row) => {
						return row.person?.genderDictionaryItem?.title || '-';
					},
				},
				{
					label: '年龄',
					prop: 'person',
					formatter: (row) => {
						return row.person?.birthDate ? getAge(row.person.birthDate) : '-';
					},
				},
				{
					label: '详细地址',
					prop: 'person',
					formatter: (row) => {
						return row.person?.homeAddress || '-';
					},
				},
				{
					label: '病情初判',
					prop: 'illnessDegreeCode',
					formatter: (row) => {
						return row.illnessDegreeCode == 1 ? '轻微' : row.illnessDegreeCode == 2 ? '中等' : row.illnessDegreeCode == 3 ? '严重' : '-';
					},
				},
				{
					label: '所属疾病',
					prop: 'diseaseDictionaryItem',
					formatter: (row) => {
						return row.diseaseDictionaryItem?.title || '-';
					},
				},
				{
					label: '转诊机构',
					prop: 'referralOrganization',
					formatter: (row) => {
						return row.referralOrganization?.title || '-';
					},
				},
				{
					label: '转诊科室',
					prop: 'department',
					formatter: (row) => {
						return row.department?.title || '-';
					},
				},
				{
					label: '接诊医生',
					prop: 'medicalWorker',
					formatter: (row) => {
						return row.medicalWorker?.title || '-';
					},
				},
				// {
				// 	label: '接诊处理方式',
				// 	prop: 'treatmentDictionaryItem',
				// 	formatter: (row) => {
				// 		return row.treatmentDictionaryItem?.title || '-';
				// 	},
				// },
				{
					label: '最终处理方式',
					prop: 'treatmentDictionaryItem',
					formatter: (row) => {
						return row.treatmentDictionaryItem?.title || '-';
					},
				},
				{
					label: '填报时间',
					prop: 'decideTime',
					formatter: (row) => {
						return row.decideTime || '-';
					},
				},
			],
			isShowDetail: false,
			options: [],
			filterLoading: false,
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getSexList();
		this.getList();
	},
	methods: {
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		onSearch() {
			this.queryData.current = 1;
			this.getList();
		},
		// 获取性别下拉
		getSexList() {
			this.$http
				.get(this.api['DictionaryItems#index'].href, { params: { dictionaryCode: 'GENDER' } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.sexDictionaryItemList = res.data.collection || [];
						this.sexDictionaryItemList.unshift({
							id: null,
							title: '全部',
						});
					}
				})
				.catch((e) => {});
		},
		//获取列表
		getList(type = '') {
			type == 'filter' ? (this.filterLoading = true) : (this.loading = true);
			let data = {
				...this.formInline,
				...this.queryData,
			};
			this.$http
				.get('/management-api/v1/ReferralConsultations.json', { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.filterLoading = false;
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.person.name,
								};
							});
						} else {
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
							this.$refs.createView.link = res.data._links.create.href || '';
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(event, isShowDetail, row) {},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .search-form {
	.el-select {
		width: 120px;
		.el-input {
			width: 120px;
			.el-input__inner {
				width: 120px;
			}
		}
	}
	.el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		p {
			color: #666;
		}
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
}
</style>